import Header from "components/Header/index";
import Sidebar from "containers/SideNav/index";
import React from "react";
import { connect } from "react-redux";
import { Route, Switch, withRouter } from "react-router-dom";
import Map from "../containers/map";
import SmallSidebar from "../containers/SmallSidebar/SmallSidebar";
import Tenant from "../pages/Tenant";
import TopNav from "components/TopNav";
import {
  ABOVE_THE_HEADER,
  BELOW_THE_HEADER,
  HORIZONTAL_NAVIGATION,
} from "constants/ActionTypes";
import { isIOS, isMobile } from "react-device-detect";
import Tour from "../components/Tour/index";
import asyncComponent from "../util/asyncComponent";
import SmallHeader from "components/SmallHeader/SmallHeader";
import Groups from "../containers/Groups";
import SuccessfulPayment from "../containers/payment/SuccessfulPayment";
import UnsuccessfulPayment from "../containers/payment/UnsuccessfulPayment";
import Users from "../containers/Users";
import AddUser from "../containers/Users/AddUser";
import InvoicePage from "../pages/InvoicePage";
import TransactionPage from "../pages/TransactionPage";
import ProfilePage from "pages/ProfilePage/ProfilePage";
import NotificationPage from "pages/Notifications/Notifications";
import MissionPage from "pages/Missions/Missions";
import AppContainer from "./AppContainer";

class App extends React.Component {
  render() {
    const { match, navigationStyle, horizontalNavPosition } = this.props;
    const drawerStyle = "mini-drawer";

    //set default height and overflow for iOS mobile Safari 10+ support.
    if (isIOS && isMobile) {
      document.body.classList.add("ios-mobile-view-height");
    } else if (document.body.classList.contains("ios-mobile-view-height")) {
      document.body.classList.remove("ios-mobile-view-height");
    }

    return (
      <AppContainer drawerStyle={drawerStyle}>
        <Tour />
        <Sidebar />
        <SmallSidebar />
        <div className="app-main-container">
          <div
            className={`app-header ${
              navigationStyle === HORIZONTAL_NAVIGATION
                ? "app-header-horizontal"
                : ""
            }`}
          >
            {navigationStyle === HORIZONTAL_NAVIGATION &&
              horizontalNavPosition === ABOVE_THE_HEADER && (
                <TopNav styleName="app-top-header" />
              )}
            <Header />
            <SmallHeader />
            {navigationStyle === HORIZONTAL_NAVIGATION &&
              horizontalNavPosition === BELOW_THE_HEADER && <TopNav />}
          </div>

          <main className="app-main-content-wrapper">
            <div className="app-main-content">
              <Switch>
                <Route path={`${match.url}/map`} component={Map} />
                <Route path={`${match.url}/groups`} component={Groups} />
                <Route path={`${match.url}/users`} component={Users} />
                <Route path={`${match.url}/add-user`} component={AddUser} />
                <Route
                  path={`${match.url}/successful/:id`}
                  component={SuccessfulPayment}
                />
                <Route
                  path={`${match.url}/unsuccessful`}
                  component={UnsuccessfulPayment}
                />

                {JSON.parse(localStorage.getItem("reseller")) && (
                  <Route path={`${match.url}/tenant`} component={Tenant} />
                )}

                <Route
                  path={`${match.url}/chat`}
                  component={asyncComponent(() =>
                    import("./routes/chatPanel/basic/index")
                  )}
                />
                {/* <Route
                  path={`${match.url}/contact`}
                  component={asyncComponent(() =>
                    import("./routes/contact/basic/index")
                  )}
                /> */}
                <Route
                  path={`${match.url}/invoice-page`}
                  component={InvoicePage}
                />
                <Route
                  path={`${match.url}/transaction-page`}
                  component={TransactionPage}
                />
                <Route
                  path={`${match.url}/profile-page`}
                  component={ProfilePage}
                />
                <Route
                  path={`${match.url}/notifications`}
                  component={NotificationPage}
                />
                <Route path={`${match.url}/missions`} component={MissionPage} />
                <Route
                  component={asyncComponent(() =>
                    import("app/routes/extraPages/routes/404")
                  )}
                />
              </Switch>
            </div>
          </main>
        </div>
      </AppContainer>
    );
  }
}

const mapStateToProps = ({ settings }) => {
  const { drawerType, navigationStyle, horizontalNavPosition } = settings;
  return { drawerType, navigationStyle, horizontalNavPosition };
};
export default withRouter(connect(mapStateToProps)(App));
